// extracted by mini-css-extract-plugin
export var connectWallet = "ConnectWalletModal-module--connectWallet--94afc";
export var connectWalletBackBtn = "ConnectWalletModal-module--connectWalletBackBtn--65acd";
export var connectWalletInner = "ConnectWalletModal-module--connectWalletInner--3bcc7";
export var connectWalletModalMessage = "ConnectWalletModal-module--connectWalletModalMessage--332df";
export var connectWalletModalMetamaskInstall = "ConnectWalletModal-module--connectWalletModalMetamaskInstall--dcbc3";